import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as e } from "../../../../core/maybe.js";
import t from "../webgl/brushes/WGLBrush.js";

var r = /*#__PURE__*/function (_t) {
  _inherits(r, _t);

  var _super = _createSuper(r);

  function r() {
    _classCallCheck(this, r);

    return _super.apply(this, arguments);
  }

  _createClass(r, [{
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "prepareState",
    value: function prepareState(e) {
      var t = e.context;
      t.setColorMask(!0, !0, !0, !0), t.setStencilFunction(514, 0, 255);
    }
  }, {
    key: "draw",
    value: function draw(t, _r) {
      var o = t.context,
          i = _r.displayData;
      if (e(i)) return;
      if ("loaded" === i.state.name && i.prepareForRendering(o, n, a), "attached" !== i.state.name) return;
      var s = i.state.resources,
          l = t.painter.materialManager.getProgram(t, {
        vsPath: "raster/flow",
        fsPath: "raster/flow",
        attributes: n
      });
      o.setFaceCullingEnabled(!1), o.setBlendingEnabled(!0), o.setBlendFunctionSeparate(1, 771, 1, 1), o.useProgram(l), l.setUniform1f("u_time", t.time / 1e3), l.setUniform1f("u_fadeDuration", i.flowStyle.renderSettings.fadeDuration), l.setUniform1f("u_lineSpeed", i.flowStyle.renderSettings.lineSpeed), l.setUniformMatrix3fv("u_dvsMat3", _r.transforms.dvs), l.setUniformMatrix3fv("u_displayViewMat3", t.state.displayViewMat3), l.setUniform4f("u_lineColor", i.flowStyle.renderSettings.lineColor[0] * t.globalOpacity, i.flowStyle.renderSettings.lineColor[1] * t.globalOpacity, i.flowStyle.renderSettings.lineColor[2] * t.globalOpacity, i.flowStyle.renderSettings.lineColor[3] * t.globalOpacity), l.setUniform1f("u_lineHalfWidth", i.flowStyle.renderSettings.lineRenderWidth / 2), o.bindVAO(s.vertexArray), o.drawElements(4, s.indexBuffer.size, 5125, 0), i.flowStyle.animated && _r.requestRender();
    }
  }]);

  return r;
}(t);

var n = new Map();
n.set("a_positionAndSide", 0), n.set("a_timeInfo", 1), n.set("a_extrude", 2);
var a = {
  geometry: [{
    name: "a_positionAndSide",
    count: 3,
    type: 5126,
    offset: 0,
    stride: 32,
    normalized: !1
  }, {
    name: "a_timeInfo",
    count: 3,
    type: 5126,
    offset: 12,
    stride: 32,
    normalized: !1
  }, {
    name: "a_extrude",
    count: 2,
    type: 5126,
    offset: 24,
    stride: 32,
    normalized: !1
  }]
};
export { r as default };